import { EPaymentGeneratorStatus } from '../enums/payment-generator.enum';
import { StatusRecord } from '../types/status.type';

export const PAYMENT_GENERATOR_PAYMENT_MODES = [
  {
    id: 'Cheque',
    name: 'By Cheque',
  },
  {
    id: 'Giro',
    name: 'Giro',
  },
] as const;

export const PAYMENT_GENERATOR_STATUS = [
  {
    id: 'Selected',
    name: 'Selected',
  },
  {
    id: 'Computed',
    name: 'Computed',
  },
  {
    id: 'Assigned',
    name: 'Assigned',
  },
  {
    id: 'EmailSent',
    name: 'Email Sent',
  },
  {
    id: 'Posted',
    name: 'Posted',
  },
];

export const PAYMENT_GENERATOR_STATUS_OPTION: StatusRecord<EPaymentGeneratorStatus> = {
  [EPaymentGeneratorStatus.Selected]: {
    id: EPaymentGeneratorStatus.Selected,
    name: 'Selected',
    class: 'status-box-default',
    detailName: 'Selected',
  },
  [EPaymentGeneratorStatus.Computed]: {
    id: EPaymentGeneratorStatus.Computed,
    name: 'Computed',
    class: 'status-box-purple',
    detailName: 'Computed',
  },
  [EPaymentGeneratorStatus.EmailSent]: {
    id: EPaymentGeneratorStatus.EmailSent,
    name: 'Email Sent',
    class: 'status-box-warning',
    detailName: 'Email Sent',
  },
  [EPaymentGeneratorStatus.Assigned]: {
    id: EPaymentGeneratorStatus.Assigned,
    name: 'Assigned',
    class: 'status-box-warning',
    detailName: 'Assigned',
  },
  [EPaymentGeneratorStatus.Posted]: {
    id: EPaymentGeneratorStatus.Posted,
    name: 'Posted',
    class: 'status-box-success',
    detailName: 'Posted',
  },
};